import { setValueInStorage } from "~/hooks/localStorageHelpers";
export const GetSampleProjectTourCurrentStepKey = (projectSlug: string) => `sampleProjectTour.${projectSlug}.currentStep`;
export const InitializeSampleProjectTour = (projectSlug: string) => {
    setValueInStorage(GetSampleProjectTourCurrentStepKey(projectSlug), "0");
};
